import { LAYOUT_OBJECT_DEFAULT_BACKGROUND_IMAGE_METHOD } from '../../constants';

export type LayoutImagePlacement = {
  x: number;
  y: number;
  width: number;
  height: number;
};

type GetLayoutImagePlacementParams = {
  method: unknown;
  imageWidth: number;
  imageHeight: number;
  boxWidth: number;
  boxHeight: number;
};

export const getLayoutImagePlacement = ({
  method,
  imageWidth,
  imageHeight,
  boxWidth,
  boxHeight,
}: GetLayoutImagePlacementParams): LayoutImagePlacement | null => {
  const normalizedMethod = (
    typeof method === 'string' && method !== ''
      ? method
      : LAYOUT_OBJECT_DEFAULT_BACKGROUND_IMAGE_METHOD
  ).toLowerCase();

  if (normalizedMethod === 'none') {
    return null;
  }

  if (normalizedMethod === 'topleft') {
    return { x: 0, y: 0, width: imageWidth, height: imageHeight };
  }

  if (normalizedMethod === 'centerfit') {
    const scale = Math.min(1, boxWidth / imageWidth, boxHeight / imageHeight);
    const width = imageWidth * scale;
    const height = imageHeight * scale;

    return {
      x: (boxWidth - width) / 2,
      y: (boxHeight - height) / 2,
      width,
      height,
    };
  }

  return {
    x: (boxWidth - imageWidth) / 2,
    y: (boxHeight - imageHeight) / 2,
    width: imageWidth,
    height: imageHeight,
  };
};
